module.exports = __webpack_public_path__ + "img/mgs.046564d6.jpg";